import {  User } from "@app/types/user";

export type CharacterStatusType = "wrong" | "good" | "answer" | "thinking" | "neutral" | "buzz";
export type CharacterImagesType = {
    wrong: any,
    good: any,
    answer: any,
    thinking: any,
    neutral: any,
    buzz: any,
};

export function getCharacterStatus(statusType?: CharacterStatusType, characterImages?: CharacterImagesType) {
    let characterStatus;

    switch (statusType) {
        case "answer":
            characterStatus = characterImages?.answer;
            break;
        case "buzz":
            characterStatus = characterImages?.buzz;
            break;
        case "good":
            characterStatus = characterImages?.good;
            break;
        case "neutral":
            characterStatus = characterImages?.neutral;
            break;
        case "thinking":
            characterStatus = characterImages?.thinking;
            break;
        case "wrong":
            characterStatus = characterImages?.wrong;
            break;
    }

    return characterStatus;
}

export function isDuplicateCharacter(
    users: User[],
    targetUser: User,
  ): boolean {
    for (const user of users) {
    if (user === targetUser) {
      break; // Arrête la recherche lorsqu'on atteint l'élément cible
    }

    if (user.character === targetUser.character) {
      return true; // Trouvé un autre élément avec le même "character" avant l'élément cible
    }
  }

  return false; // Aucun doublon trouvé avant l'élément cible
  }

export function getNumberOfCharacter(
    users: User[],
    targetUser: User,
  ): number {
  let count = 0;

  if (users && targetUser.character) {
    for (const user of users) {
      if (user.character === targetUser.character) {
        count++;
      }
    }
  }

  return count;
}

export function getUsersVisible(
    users: User[],
    myUserId: string,
  ): User[] {
  const myIndex = users.findIndex((user) => user.id === myUserId);

  if (myIndex === -1) {
    return []; // User ID non trouvé
  }

  const totalToGet = 8;
  const before = 3;
  const after = 4;

  let start = Math.max(0, myIndex - before);
  let end = Math.min(users.length, myIndex + after + 1); // +1 car slice est exclusif

  // Ajustement si on est proche du début ou de la fin
  const actualLength = end - start;
  if (actualLength < totalToGet) {
    const missing = totalToGet - actualLength;

    // Essayer d'étendre la fenêtre vers la gauche
    start = Math.max(0, start - missing);

    // Si pas assez à gauche, essayer vers la droite
    end = Math.min(users.length, end + (totalToGet - (end - start)));
  }

  return users.slice(start, end);
}
